import './App.css';
import {make as MM_cmp_root} from "./metamath/ui/MM_cmp_root.bs";

function App() {
  return <MM_cmp_root/>
}

export default App;
